import _, { mergeWith } from 'lodash';
import clone from 'lodash/clone';
import isArray from 'lodash/isArray';

import getDefaultPulses from '~lib/common/utils/getDefaultPulses';

export default function updateCaseConf(caseConf, updates) {
  const updatedCaseConf = mergeWith(caseConf, updates, (objValue, srcValue, key) => {
    if (key === '_initialStates') {
      return _(srcValue || [])
        .concat(objValue || [])
        .uniqBy('id')
        .reverse()
        .value();
    }
    if (key === '_startLocation' || key === '_endLocation') {
      return clone(srcValue);
    }
    if (key === '_sounds') {
      return clone(srcValue);
    }
    if (key === 'endConditions') {
      return clone(srcValue);
    }
    if (
      key === 'grading' ||
      key === 'caseLogic' ||
      key === 'calls' ||
      key === '_treatments' ||
      key === '_oxygens'
    ) {
      return clone(srcValue);
    }
    if (key === 'tags') {
      return clone(srcValue);
    }
    if (key === 'caseLogicDescription') {
      return clone(srcValue);
    }
    if (key === 'physicalAssessments') {
      return clone(srcValue);
    }
    if (key === 'moulages' || key === 'structuralMoulages') {
      return clone(srcValue);
    }
    if (key === 'dialogue') {
      return {
        ...objValue,
        ...srcValue,
      }
    }
    if (key === 'iv') {
      return clone(srcValue);
    }
    if (isArray(srcValue)) {
      return clone(srcValue);
    }
    return undefined;
  });

  // Sync pulse values with BP as long has the sync has not been
  // disable, e.g. by changing pulse strength manually
  // This only happens for new cases
  const bpHasChanged = !!updates._initialStates;
  const bpSyncEnabled =
    !caseConf.initialConditions ||
    !caseConf.initialConditions.disablePulseBpSync;
  const bpSyncToggledOn =
    !!updates.initialConditions && updates.initialConditions.disablePulseBpSync === false;
  if ((bpHasChanged && bpSyncEnabled) || bpSyncToggledOn) {
    const systolicBPState = bpHasChanged
      ? updates._initialStates.find((s) => s.id === 'BPSystolic')
      : caseConf._initialStates.find((s) => s.id === 'BPSystolic');
    if (systolicBPState) {
      const systolicBp = parseFloat(systolicBPState.options.value);
      updatedCaseConf.initialConditions =
        updatedCaseConf.initialConditions || {};
      updatedCaseConf.initialConditions.pulses = getDefaultPulses(systolicBp);
    }
  }

  return updatedCaseConf;
}
